import React from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions } from 'antd';
import type { ModalProps } from 'antd';
import Datetime from 'vl-common/src/components/Datestamp';
import { InfoModal } from 'vl-common/src/components/Modals';
import type { AppointmentSecurity } from 'vl-common/src/schemas/getCliniciansApptSec';

interface PatientInfoProps extends ModalProps {
  data: AppointmentSecurity;
}

const PatientInfo = ({ data, ...others }: PatientInfoProps) => {
  const { t } = useTranslation('common');
  return (
    <InfoModal title="Patient Details" data-testid="patient-details" {...others}>
      <Descriptions column={1}>
        <Descriptions.Item label={t('Name')}>{data?.name}</Descriptions.Item>
        <Descriptions.Item label={t('Postcode')}>{data?.postcode}</Descriptions.Item>
        <Descriptions.Item label={t('Email Address')}>{data?.email}</Descriptions.Item>
        <Descriptions.Item label={t('Preferred Contact Method')}>
          {data?.tel_pref_no === 'O' ? t('Other') : t('Mobile')}
        </Descriptions.Item>
        <Descriptions.Item label={t('Mobile')}>{data?.tel_mobile_no}</Descriptions.Item>
        {data?.tel_other_no && <Descriptions.Item label={t('Other')}>{data?.tel_other_no}</Descriptions.Item>}
        <Descriptions.Item label={t('Date of Birth')}>
          {data?.dob && <Datetime date={new Date(data.dob)} format="Date only (localised) - 03/02/2022" />}
        </Descriptions.Item>
      </Descriptions>
    </InfoModal>
  );
};

export default PatientInfo;
